module.exports = __webpack_public_path__ + "img/maingau-ic.76736307.svg";